<template>
    <div class="select-container" :class="isCollapse ? 'collapse' : ''">
        <div class="input-container">
            <div></div>
            <div class="select" @click="showOption">
                <div>{{value?showOptions[value]:showOptions[defaultVal]}}</div>
                <div :class="optionsShow?'down':'up'"></div>
            </div>
            <div></div>
        </div>
        <div class="options" v-show="optionsShow">
            <div v-for="item in options" :key="item.value" @click="pickValue(item.value)">{{ item.name }}</div>
        </div>
    </div>
</template>

<script>
import { useScreenState } from "../store";

export default {
    name: "PangSelect",
    props: {
        value: String,
        options: {
            type: Array,
            required: true,
        }
    },
    data() {
        return {
            screenState: useScreenState(),
            defaultVal: this.options[0].value,
            optionsShow: false,
            showOptions: this.options.reduce(function (res, x) {
                res[x.value] = x.name
                return res;
            }, {}),
        };
    },
    setup(props, { emit }) {
        const updateValue = (value) => {
        emit("update:value", value);
        };
        return { updateValue };
    },
    computed: {
        isCollapse() {
        return this.screenState.screenWidth < 1200;
        },
    },
    methods: {
        showOption () {
            this.optionsShow = !this.optionsShow;
        },
        pickValue (value) {
            this.optionsShow = false;
            this.updateValue(value)
        },
    },
    mounted() {
    },
};
</script>

<style scoped>


.input-container {
    display: flex;
    width: 120px;
}

.input-container > div:first-child {
    width: 20px;
    height: 50px;
    background-image: url(../assets/images/img_frame01_gift.png);
    background-repeat: no-repeat;
}

.input-container > div:last-child {
    width: 20px;
    height: 50px;
    background-image: url(../assets/images/img_frame03_gift.png);
    background-repeat: no-repeat;
    margin-top: 7px;
}

.select {
    line-height: 43px;
    overflow: hidden;
    width: calc(100% - 40px);
    background-image: url(../assets/images/img_frame02_gift.png);
    background-repeat: repeat-x;
    margin-top: 7px;
    cursor: pointer;
    display: flex;
}

.options {
    position: absolute;
    border: 1px solid #c7c7c7;
    background-color: #701013;
    width: 104px;
    margin-left: 4px;
    text-align: center;
}

.options > div {
    cursor: pointer;
}

.select > .up {
    width:0;
    height:0;
	border-right: 8px solid transparent;
	border-left: 8px solid transparent;
	border-bottom: 8px solid #c7c7c7;
    display: inline-block;
    margin: auto;
    margin-top: 18px;
}

.select > .down {
    width:0;
	height:0;
	border-right: 8px solid transparent;
	border-left: 8px solid transparent;
	border-top: 8px solid #c7c7c7;
    display: inline-block;
    margin: auto;
    margin-top: 18px;
}


.collapse .select {
    height: 8.2vw;
    line-height: 8.2vw;
    width: 20vw;
    margin-top: 1.3vw;
    background-size: 100% 100%;
    font-size: 3.2vw;
    background-image: url(../assets/images/img_frame02_gift.png);
}

.collapse .input-container > div:first-child {
    background-size: 100% 100%;
    height: 9.5vw;
    width: 2.65vw;
    background-image: url(../assets/images/img_frame01_gift.png);
}

.collapse .input-container > div:last-child {
    background-size: 100% 100%;
    height: 9.4vw;
    width: 2.37vw;
    margin-top: 1.3vw;
    background-image: url(../assets/images/img_frame03_gift.png);
}

.collapse .input-container {
    width: 25vw;
}

.collapse .select > .up {
	border-right: 1vw solid transparent;
	border-left: 1vw solid transparent;
	border-bottom: 1vw solid #c7c7c7;
    margin-top: 4vw;
}

.collapse .select > .down {
	border-right: 1vw solid transparent;
	border-left: 1vw solid transparent;
	border-top: 1vw solid #c7c7c7;
    margin-top: 4vw;
}

.collapse .options {
    width: 23.5vw;
    margin-left: 0.5vw;
    font-size: 3.2vw;
}
</style>
